import { ITenant } from '../interfaces';

export const tenant = localStorage.getItem('@voucher:tenant');
export const dataTenant: ITenant = JSON.parse(
  localStorage.getItem('@voucher:dataTenant') as string,
);
